import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";

import { App } from "../../../../routes/Constants";
import { usePrefersReducedMotion } from "../../../../hooks/usePrefersReducedMotion";

const initialShadow = "0px 5px 15px rgba(0, 0, 0, 0.08)";

export const ReferAPatient = () => {
  const navigate = useNavigate();
  const reduced = usePrefersReducedMotion();

  const goToPatientInitiation = () => {
    navigate(App.PATIENT_INITIATION);
  };

  const handleCardKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      goToPatientInitiation();
    }
  };

  return (
    <motion.div
      role="button"
      tabIndex={0}
      data-testid="dashboard-card-refer-patient"
      className="group relative flex w-[500px] max-w-full cursor-pointer items-center justify-around gap-2 overflow-hidden rounded-2xl bg-[#dce6f2] px-7 py-6 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#005B82]"
      initial={
        reduced
          ? false
          : { opacity: 0, scale: 0.9, boxShadow: initialShadow }
      }
      animate={{ opacity: 1, scale: 1, boxShadow: initialShadow }}
      transition={
        reduced
          ? { duration: 0 }
          : { delay: 0.5, type: "spring", stiffness: 100, damping: 18 }
      }
      whileHover={
        reduced
          ? {}
          : {
            scale: 1.03,
            y: -8,
            boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.15)",
          }
      }
      whileTap={reduced ? {} : { scale: 0.98 }}
      onClick={goToPatientInitiation}
      onKeyDown={handleCardKeyDown}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-2xl bg-[rgba(255,255,255,0)] transition-colors duration-300 group-hover:bg-[rgba(255,255,255,0.1)]"
        aria-hidden
      />
      <div className="relative z-[1] max-w-60">
        <motion.p
          className="text-3xl font-bold leading-tight text-[#005B82]"
          data-testid="dashboard-card-refer-patient-title"
          initial={reduced ? false : { opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: reduced ? 0 : 0.7 }}
        >
          Refer Patient
        </motion.p>
        <motion.p
          className="mt-2 text-base font-medium text-[#3f7292]"
          data-testid="dashboard-card-refer-patient-description"
          initial={reduced ? false : { opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: reduced ? 0 : 0.8 }}
        >
          Refer a patient to the portal
        </motion.p>
      </div>
      <motion.div
        className="relative z-[1]"
        data-testid="dashboard-card-refer-patient-icon"
        initial={reduced ? false : { rotate: -5, opacity: 0 }}
        animate={{ rotate: 0, opacity: 1 }}
        transition={{ duration: reduced ? 0 : 0.8, delay: reduced ? 0 : 0.6 }}
      >
        <motion.div
          whileHover={
            reduced ? {} : { rotate: 5, scale: 1.05 }
          }
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <img src="/icons/PillsBottle.png" alt="Refer a Patient" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
